import {Group, Mesh, Points, ShaderMaterial, Object3D} from 'three'

/**
 * Утилитный класс для обновления uniforms в объектах Three.js
 * Устраняет дублирование логики обновления uniforms
 */
export class UniformsUpdater {
  /**
   * Обновление uniforms для всех материалов в группе
   * @param group Группа объектов
   * @param currentTime Текущее время в секундах
   * @param uniformNames Массив имен uniforms для обновления (например, ['iTime', 'uTime'])
   */
  static updateUniformsInGroup(
    group: Object3D,
    currentTime: number,
    uniformNames: string[] = ['iTime', 'uTime']
  ): void {
    if (!(group instanceof Group)) {
      return
    }

    group.children.forEach((child) => {
      if (child instanceof Mesh && child.material instanceof ShaderMaterial) {
        this.updateMaterialUniforms(child.material, currentTime, uniformNames)
      }
    })
  }

  /**
   * Обновление uniforms для всех Points в группе
   * @param group Группа объектов
   * @param currentTime Текущее время в секундах
   * @param uniformNames Массив имен uniforms для обновления
   */
  static updateUniformsInPoints(
    group: Object3D,
    currentTime: number,
    uniformNames: string[] = ['uTime']
  ): void {
    if (!(group instanceof Group)) {
      return
    }

    group.traverse((child) => {
      if (child instanceof Points && child.material instanceof ShaderMaterial) {
        this.updateMaterialUniforms(child.material, currentTime, uniformNames)
      }
    })
  }

  /**
   * Обновление uniforms в материале
   * @param material Шейдерный материал
   * @param currentTime Текущее время в секундах
   * @param uniformNames Массив имен uniforms для обновления
   */
  static updateMaterialUniforms(
    material: ShaderMaterial,
    currentTime: number,
    uniformNames: string[]
  ): void {
    const timeOffset = material.userData.timeOffset || 0
    const uniforms = material.uniforms

    if (!uniforms) {
      return
    }

    uniformNames.forEach((uniformName) => {
      if (uniforms[uniformName]) {
        uniforms[uniformName].value = currentTime + timeOffset
      }
    })
  }
}
